// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__FpZfv","file":"styles_file__15X8z"};